import React from 'react';
import MiCompAPI from '../../../util/api';
import { Form, Input, Button, Row, Col,  InputNumber, Select,Icon } from 'antd';
import InputMask from "react-input-mask";
// import img from '../../../assets/img/Illustration.png';

const { Option } = Select;
class BrokerForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
    this.api = new MiCompAPI(null);
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submitHandler({ ...values, user_id: this.props.id,isexistprofile:this.props.isexistprofile });
      }
    });
  }
  componentDidMount = () => {

    const { setFieldsValue } = this.props.form;
    const { data,isexistprofile } = this.props;
    if (data) {
      if(!isexistprofile)
      setTimeout(() => {
        setFieldsValue({
          first_Name: data.first_Name,
          last_Name: data.last_Name,
          email: data.user.email,
          country: 'United States'
        });
      }, 100);
      else
      setTimeout(() => {
        setFieldsValue({
          first_Name: data.first_Name,
          last_Name: data.last_Name,
          email: data.email,
          middle_Name:data.middle_Name,
          npn:data.npn,
          title:data.title,
          phone_No:data.phone_No,
        });
      }, 100);
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { isexistprofile } = this.props;

    return (
      <div className="mi_model_popup">

      <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">First Name</legend>
                  {getFieldDecorator('first_Name', {
                    rules: [{ required: true, message: 'Please enter first name' },
                    {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets,No whitespace at the beginning and end"
                    }],
                  })(<Input type="text" className="mi_input" autoComplete={"nope"}  placeholder="Enter First Name *"/>
                  )}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Middle Name</legend>
                  {getFieldDecorator('middle_Name', {
                    rules: [{ required: false, message: 'Please enter Middle Name' }, {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets,No whitespace at the beginning and end"
                    }],
                  })(<Input type="text" autoComplete={"nope"}  className="mi_input" placeholder="Enter Middile Name" />)}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Last Name</legend>
                  {getFieldDecorator('last_Name', {
                    rules: [{ required: true, message: 'Please enter Last Name' }, {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets,No whitespace at the beginning and end"
                    }],
                  })(<Input type="text" autoComplete={"nope"}  className="mi_input" placeholder="Enter Last Name *" />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>

              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Title </legend>
                  {getFieldDecorator('title', {
                    rules: [{ required: false, message: 'Please enter Middle Name' }, {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets,No whitespace at the beginning and end"
                    }],
                  })(<Input type="text" autoComplete={"nope"}  className="mi_input" placeholder="Enter Title " />)}
                </fieldset>
              </Form.Item>
            </Col>


          </Row>
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Email Id</legend>
                  {getFieldDecorator('email', {
                    rules: [{
                      type: 'email', message: 'The input is not valid E-mail!.',
                    }, { required: true, message: 'Please enter Broker Email.' },
                    { whitespace: true, message: "Email is invalid." },
                    {
                      pattern: /^([a-zA-Z0-9\s.]+)@([a-zA-Z0-9]+)\.([a-zA-Z]{2,5})$/,
                      message: 'Email is invalid.'}],
                  })(<Input disabled type="text" autoComplete={"nope"}  className="mi_input" placeholder="Enter Email Id *"  />)}
                </fieldset>
              </Form.Item>
            </Col >
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Phone Number</legend>
                  {getFieldDecorator('phone_No', {
                    rules: [{ required: false, message: 'Please enter phone number.' },
                    { pattern: /^((\+0?1\s)?)\(?\d{3}\)?[\s.\s]\d{3}[\s.-]\d{4}$/,
                    message: 'phone number is invalid'}],
                  })(<InputMask mask="+1 (999) 999-9999" autoComplete={"nope"}  className="ant-input mi_input" placeholder="Enter Phone Number" />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">NPN</legend>
                  <div>
                    {getFieldDecorator('npn', {
                      rules: [{ required: false, message: 'Please enter NPN.' }, {
                        pattern: /^(?!\s)(?![\s\S]*\s$)[0-9]{9,9}$/,
                        message: "It allows only Numerics,Value length should be 9 and No whitespace at the beginning and end"
                      }],
                    })(<InputNumber autoComplete={"nope"}  minLength={9} maxLength={9} className="ant-input mi_input" type="text" placeholder="Enter NPN" />)}
                  </div>
                </fieldset>
              </Form.Item>
            </Col>
            {/* <Col  sm={24} >
            <fieldset className="mi_input_pop">
                  <legend>LOA</legend>
              {getFieldDecorator("loas", {
                rules: [
                  { required: true, message: "Please enter a valid zip code" },
                ],
              })(
                <Select className="mi_input"
                  mode="multiple"
                  optionFilterProp="children"
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Please Select">
                  {this.props.lob.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
                </Select>
              )}</fieldset>
            </Col> */}
          </Row>
          {!isexistprofile?<>
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Mailing Address 1</legend>
                  {getFieldDecorator('street', {
                    rules: [{ required: true, message: 'Please enter street details.' }, {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s_,/,#,-]+$/,
                      message: "It allows only Alphanumerics _,/,#,-,No whitespace at the beginning and end"
                    }],
                  })(<Input autoComplete={"nope"}  maxLength={255} className="mi_input" type="text" placeholder="Enter MAilling Adress1 *" />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Mailing Address 2</legend>
                  {getFieldDecorator('street1', {
                    rules: [{ required: false, message: 'Please enter street details.' }, {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s_,/,#,-]+$/,
                      message: "It allows only Alphanumerics _,/,#,-,No whitespace at the beginning and end"
                    }],
                  })(<Input autoComplete={"nope"}  maxLength={255} className="mi_input" type="text" placeholder="Enter Mailing Address 2"/>)}
                </fieldset>
              </Form.Item>
            </Col>
            </Row>
            <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Mailing Address City</legend>
                  {getFieldDecorator('city', {
                    rules: [{ required: true, message: 'Please enter city.' }, {
                      pattern:  /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets,No whitespace at the beginning and end"
                    }],
                  })(<Input autoComplete={"nope"}  maxLength={40} className="mi_input" type="text" placeholder="Enter Mailing Address City *"  />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Mailing Address State</legend>
                  {getFieldDecorator('stateID', {
                    rules: [{ required: true, message: 'Please enter state name' }],
                  })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input"

                    showSearch={true}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={this.handleChange}
                    placeholder="Enter Mailing Address State *"
                  >
                    {this.props.states ? this.props.states.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>) : null}
                  </Select>)}
                </fieldset>
              </Form.Item>
            </Col>


            </Row>
            <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Mailing Address ZIP Code </legend>
                  {getFieldDecorator("zipCode", {
                    rules: [
                      { required: true, message: "Please enter a valid zip code" }
                      , {
                        pattern: /^\d{5}(?:[-\s]\d{4})?$/,
                       message: 'Zip code is invalid'
                     }
                    ],
                  })(
                    <InputMask mask="99999" autoComplete={"nope"}  type="text" className="ant-input mi_input" placeholder="Enter Mailing Address ZIP Code *" />
                  )}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Mailing Address Country</legend>
                  {getFieldDecorator('country', {
                    rules: [{ required: false, message: 'Please enter street details.' }],
                  })(<Input disabled  autoComplete={"nope"}  maxLength={255} className="mi_input" type="text" placeholder="Enter Mailing Address Country"  />)}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
          </>:""}

        <Row span={24} className="ant-row1">

            <Form.Item>
              <Button className="submit-button" htmlType="submit" style={{float:'right',marginRight:"20px"}} type="primary">
                Submit
              </Button>
            </Form.Item>

        </Row>
      </Form>
      </div>
    );
  }
}
export default BrokerForm;